<template>
	<div id="footer_container"></div>
</template>

<script>
export default {
	data() {
		return {
			keyword: '',
			ready: false,
			commanded: false
		};
	},
	created() {
		this.keyword = window.config.keyword;
		window.onclick = this.windowClick;
	},
	mounted() {
		this.fetchFooter();
	},
	methods: {
		windowClick: function(evt) {
			var self = this;

			if (!self.commanded) {
				var head = document.getElementById('footer_container');
				head.shadowRoot.querySelectorAll('.dropdown').forEach(dd => {
					dd.classList.remove('open');
				});
			}

			self.commanded = false;
		},
		navClick: function(evt) {
			var current = evt.target;
			var firstParent = evt.target.parentNode;
			var secondParent = firstParent.parentNode;
			var drop = false;
			var self = this;
			var head = document.getElementById('footer_container');

			if (current.classList.contains('dropdown')) {
				drop = current;
			}

			if (firstParent.classList.contains('dropdown')) {
				drop = firstParent;
			}

			if (secondParent.classList.contains('dropdown')) {
				drop = secondParent;
			}

			if (drop) {
				if (drop.classList.contains('open')) {
					drop.classList.remove('open');
				} else {
					drop.classList.add('open');
				}
			}
		},
		fetchFooter: function() {
			let self = this;
			const req = new Request(
				`https://${this.keyword}.libnet.info/vfooter`
			);
			fetch(req)
				.then(response => {
					return response.text();
				})
				.then(html => {
					this.processFooter(html);
				});
		},
		processFooter: function(html) {
			var dummy = document.createElement('div');
			var $el = document.getElementById('footer_container');
			var sr = $el.attachShadow({ mode: 'open' });
			var self = this;
			dummy.innerHTML = html;

			var links = dummy.querySelectorAll('link');
			links.forEach(link => {
				//var pr = link.parentNode;
				var h = link.getAttribute('href');
				if (h && h.indexOf('/css') === 0) {
					dummy.removeChild(link);
					link.href = `https://${this.keyword}.libnet.info${h}`;
					dummy.appendChild(link);
				}
			});

			var scripts = dummy.querySelectorAll('script');
			scripts.forEach(script => {
				script.remove();
			});

			sr.innerHTML = dummy.innerHTML;
			sr.querySelectorAll('.dropdown').forEach(dd => {
				dd.addEventListener('click', evt => {
					self.commanded = true;
					self.navClick(evt);
				});
			});

			this.ready = true;
		}
	}
};
</script>
<style lang="scss">
#footer_container {
	margin: 0 auto;
	transition: visibility 0s linear 0s, opacity 300ms;
	width: 100%;
	margin: 0px 10px 0px 10px;
}
</style>
